import React from "react";
import "../NFTDetailDesign.css";
const LoadingError = ({ title = "Unable to load comments", msg = "Something went wrong while loading comments. Please check your connection and try again.", callBack, retry = true }) => {
    return (

        <div className="d-flex flex-column justify-content-center align-items-center text-center py-5 px-3">
            <div className="mb-3" style={{
                fontSize: 48,
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "rgba(220, 53, 69, 0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <i className="fas fa-exclamation-triangle text-danger"></i>
            </div>
            <div className="fw-semibold mb-2" style={{ fontSize: 18, color: "#dc3545" }}>{title}</div>
            <div className="small text-muted mb-4" style={{ maxWidth: "300px" }}>{msg}</div>
            {
                retry && <button
                    onClick={() => callBack()}
                    className="btn btn-sm btn-outline-danger px-4"
                    style={{ borderRadius: "20px" }}
                >
                    <i className="fas fa-redo me-2"></i>
                    Try Again
                </button>
            }

        </div>

    );
};

export default LoadingError;